import React from "react";

const TemplateMessageList = () => {
  return <div>template list</div>;
};

export default TemplateMessageList;
